import { HTTPAPI } from "../base";

const grabToken = () => {
    const uInfoTxt = localStorage.getItem("userInfo");    
    let uInfo = null;
    if(uInfoTxt) {
        uInfo = JSON.parse(uInfoTxt);
    }
    const token = uInfo != null ? uInfo.token : "";    
    return token;
}

const event = {    
    getList: (urlCriteria) => {        
        return HTTPAPI(grabToken())
        .get("/event" + urlCriteria)
    },

    getListAdpointStats: (urlCriteria) => {        
        return HTTPAPI(grabToken())
        .get("/event/adpointstats" + urlCriteria)
    },

    getCountAdpointStats: (urlCriteria) => {
        return HTTPAPI(grabToken())
        .get("/event/adpointstats/count" + urlCriteria)
    },

    getErrorList: (urlCriteria) => {        
        return HTTPAPI(grabToken())
        .get("/event/errors" + urlCriteria)
    },

    getInitData: () => {
        return HTTPAPI(grabToken())
        .get("/adpoint/initdata")
    },
}

export default event;
